define('app',['models/AppModel'], function (appModel) {
    //  return appModel Singleton
    return new appModel();
});
